import { render } from "./FrequencyDurationChart.vue?vue&type=template&id=18916846&scoped=true"
import script from "./FrequencyDurationChart.vue?vue&type=script&lang=js"
export * from "./FrequencyDurationChart.vue?vue&type=script&lang=js"

import "./FrequencyDurationChart.vue?vue&type=style&index=0&id=18916846&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18916846"]])

export default __exports__